// Photo-upload behaviour for the Sell Your Watch form:
// validates type/size, shows chosen filenames, blocks submit until valid.
(function () {
  var ALLOWED = ['image/jpeg', 'image/png', 'image/gif'];

  function init() {
    var form = document.querySelector('.awad-sell-form');
    if (!form) return;
    var maxMb = parseInt(form.getAttribute('data-upload-max-mb') || '8', 10);
    var inputs = Array.prototype.slice.call(form.querySelectorAll('input[type="file"]'));
    if (!inputs.length) return;

    inputs.forEach(function (input) {
      var label = input.closest('label');
      var note = document.createElement('span');
      note.className = 'awad-upload-note';
      if (label) label.appendChild(note);

      input.addEventListener('change', function () {
        note.textContent = '';
        note.classList.remove('is-error');
        var files = Array.prototype.slice.call(input.files || []);
        if (!files.length) return;

        var bad = files.filter(function (f) {
          return ALLOWED.indexOf(f.type) === -1;
        });
        var big = files.filter(function (f) {
          return f.size > maxMb * 1024 * 1024;
        });

        if (bad.length) {
          note.textContent = 'Only JPG, PNG or GIF images can be uploaded.';
          note.classList.add('is-error');
          input.value = '';
          return;
        }
        if (big.length) {
          note.textContent = 'Each photo must be under ' + maxMb + 'MB.';
          note.classList.add('is-error');
          input.value = '';
          return;
        }
        note.textContent = files.map(function (f) { return f.name; }).join(', ');
      });
    });

    form.addEventListener('submit', function (event) {
      if (form.querySelector('.awad-upload-note.is-error')) {
        event.preventDefault();
        return;
      }
      // No endpoint configured yet: don't silently post to a page that can't
      // receive attachments — tell the visitor how to reach us instead.
      if (form.getAttribute('action') === '/pages/contact-us') {
        event.preventDefault();
        window.location.href = '/pages/contact-us';
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
